import { REVIEW_DETAILS } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackViewReview = async (context) =>
  trackBaseEvent(context, {
    eventName: REVIEW_DETAILS,
    properties: {},
  });
